import icon from '@material-ui/icons/Person'

const shortUrls = { icon, options: { label: 'shortUrls' } }

export default shortUrls
